import API from '.';

export default class SourceSystemIdType {
  /**
   * The Timezone dimension table for UDM
   * @param {int} sourceSystemIdTypeId The database ID for the SourceSystemIdType
   * @param {String} sourceSystemIdTypeName The name of the SourceSystemIdType
   * @param {String} sourceSystemIdTypeDesc Description of the SourceSystemIdType
   * @param {int} sourceSystemId The database ID for the SourceSystem
   * @param {bool} isActive '1' for active, '0' for inactive
   */
  constructor({sourceSystemIdTypeId, sourceSystemIdTypeName, sourceSystemIdTypeDesc, sourceSystemId, isActive}) {
    this.sourceSystemIdTypeId = sourceSystemIdTypeId;
    this.sourceSystemIdTypeName = sourceSystemIdTypeName;
    this.sourceSystemIdTypeDesc = sourceSystemIdTypeDesc;
    this.sourceSystemId = sourceSystemId;
    this.sourceSystemIdTypeIsActive = isActive;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/sourceSystemIdType');
    return data.map((d) => new SourceSystemIdType(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`sourceSystemIdType/${id}`);
    return new SourceSystemIdType(data);
  }
}
